module.exports = __webpack_public_path__ + "static/reimageIT1-f83c45af1137c187d05031b9b111b32a.png";